import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "profileListViewItemRightPart" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-euro smallPiIcon planName" }, null, -1)
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormatDate = _resolveComponent("FormatDate")!
  const _component_GeolocationView = _resolveComponent("GeolocationView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString($props.aUserProfile.OUPData.UPEmail) + " " + _toDisplayString($props.aUserProfile.OUPData.UPName) + " " + _toDisplayString($props.aUserProfile.OUPData.UPPseudo) + " " + _toDisplayString($props.aUserProfile.OUPData.UPDescription) + " " + _toDisplayString($props.aUserProfile.OUPData.UPPhoneNumber) + " ", 1),
      ($props.aUserProfile.OUPData.UPSubscriptionPlanId)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            title: $props.aUserProfile.OUPData.UPSubscriptionPlanId
          }, [
            _hoisted_3,
            _createTextVNode(_toDisplayString($props.aUserProfile.getSubscriptionPlanName()), 1)
          ], 8, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_FormatDate, {
        prefix: "Fin d'abonnement ",
        inputDate: $props.aUserProfile.OUPData.UPSubscriptionEndedOn
      }, null, 8, ["inputDate"])
    ]),
    ($props.aUserProfile.OUPData.UPLocation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_GeolocationView, {
            aLocation: $props.aUserProfile.OUPData.UPLocation
          }, null, 8, ["aLocation"])
        ]))
      : _createCommentVNode("", true)
  ]))
}